import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  oiRoot: {
    flexDirection: "column",
    "& p": {
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.spacing(0.3)
    }
  }
}));
